import { handleRoute } from "../https";

export async function getEmployees({ companyId, params, query = "" }) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/employees?${query}`,
    payload: params,
  });
  return res;
}

export async function getEmployeesV2({ companyId, query = "" }) {
  const res = await handleRoute({
    method: "get",
    path: `/v2/companies/${companyId}/employees?${query}`,
  });
  return res;
}

export async function getEmployee({ companyId, employeeId }) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/employees/${employeeId}`,
  });
  return res;
}

export async function getEmployeeSnapshot({ companyId, employeeId }) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/employees-snapshot/${employeeId}`,
  });
  return res;
}

export async function createEmployees({ employees, companyId }) {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${companyId}/upload-employees`,
    payload: { employees },
  });
  return res.data.response;
}

export async function editEmployee({ companyId, employee }) {
  const res = await handleRoute({
    method: "put",
    path: `/v1/companies/${companyId}/uploaded-employees/${employee.id}`,
    payload: { employee },
  });
  return res;
}

export async function getEmployeeBulkSession(companyId) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/edit-employee-in-bulk-session`,
  });
  return res;
}

export async function editEmployeeBulkSession({ companyId, employeeIds }) {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${companyId}/edit-employee-in-bulk-session`,
    payload: { employeeIds },
  });
  return res;
}

export async function updateEmployeesBulkSessionByCsv({
  companyId,
  employees,
}) {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${companyId}/edit-employee-in-bulk-session/upload-csv`,
    payload: { employees },
  });
  return res;
}

export async function commitChangesEmployeesBulkSession(companyId) {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${companyId}/edit-employee-in-bulk-session/commit`,
  });
  return res;
}

export async function updateEmployeesBulkSession({ companyId, employee }) {
  const res = await handleRoute({
    method: "put",
    path: `/v1/companies/${companyId}/edit-employee-in-bulk-session/${employee.id}`,
    payload: { employee },
  });
  return res;
}

export async function deleteEmployeesBulkSession({ companyId, employeeIds }) {
  const res = await handleRoute({
    method: "delete",
    path: `/v1/companies/${companyId}/edit-employee-in-bulk-session/remove-employees`,
    payload: { employeeIds },
  });
  return res;
}

export async function deleteProcessEmployeesBulkSession(companyId) {
  const res = await handleRoute({
    method: "delete",
    path: `/v1/companies/${companyId}/edit-employee-in-bulk-session`,
  });
  return res;
}

export async function enableEmployees(employeeIds, companyId) {
  const res = await handleRoute({
    method: "put",
    path: `/v1/companies/${companyId}/enable-employees`,
    payload: { employeeIds },
  });
  return res;
}

export async function disableEmployees(employeeIds, companyId) {
  const res = await handleRoute({
    method: "put",
    path: `/v1/companies/${companyId}/disable-employees`,
    payload: { employeeIds },
  });
  return res;
}
export async function removeActiveEmployees({ companyId, payload }) {
  const res = await handleRoute({
    method: "delete",
    path: `/v1/companies/${companyId}/employees`,
    payload,
  });
  return res;
}

export async function removeUploadingEmployees({ employeeIds, companyId }) {
  const res = await handleRoute({
    method: "delete",
    path: `/v1/companies/${companyId}/upload-employees`,
    payload: { employeeIds },
  });
  return res;
}

export async function sendInviteEmployees({ employees, companyId }) {
  const res = await handleRoute({
    method: "post",
    path: `/v1/companies/${companyId}/invite-employees`,
    payload: { employees },
  });
  return res;
}

export async function updateEmployeeModel({ companyId, employeeIds, modelId }) {
  const res = await handleRoute({
    method: "put",
    path: `v1/companies/${companyId}/employees/benefit-model`,
    payload: { employeeIds, modelId },
  });
  return res;
}

export async function updateEmployeeTaxRegime({
  companyId,
  employeeIds,
  taxRegime,
}) {
  const res = await handleRoute({
    method: "put",
    path: `v1/companies/${companyId}/employees/tax-regime`,
    payload: { employeeIds, taxRegime },
  });
  return res;
}

export async function downloadNovationContract(companyId, idNovationContract) {
  const res = await handleRoute({
    method: "get",
    path: `v1/companies/${companyId}/download-novation-contract/${idNovationContract}`,
    payload: { responseType: "blob" },
  });
  return res;
}

export const getPayrollAdjustmentsOfEmployeesToDelete = async ({
  companyId,
  employees,
  pageSize = 10,
  pageNumber = 1,
}) => {
  const res = await handleRoute({
    method: "post",
    path: `v1/companies/${companyId}/employee-removal-summary/payroll-adjustments`,
    payload: { employeeIds: employees, pageSize, pageNumber },
  });
  return res;
};

export const getBenefitBags = async ({ companyId, employeeIds }) => {
  const res = await handleRoute({
    method: "get",
    path: `v1/companies/${companyId}/benefit-bags`,
    payload: { params: { employeeIds } },
  });
  return res;
};

export const getPendingPaymentsByEmployees = async ({
  companyId,
  employees,
}) => {
  const res = await handleRoute({
    method: "get",
    path: `v1/companies/${companyId}/pending-payments`,
    payload: { params: { employeeIds: employees } },
  });
  return res;
};

export const getCardBalancesOfEmployeesToDelete = async ({
  companyId,
  employees,
}) => {
  const res = await handleRoute({
    method: "post",
    path: `v1/companies/${companyId}/employee-removal-summary/cards`,
    payload: { employeeIds: employees },
  });
  return res;
};

export const deleteEmployees = async ({ companyId, payload }) => {
  const res = await handleRoute({
    method: "delete",
    path: `v1/companies/${companyId}/employees`,
    payload,
  });
  return res;
};

type employeesStatusParams = {
  companyId: string;
  employees: {
    employeeId: string;
    status?: string;
    note?: string;
  }[];
};

export const updateEmployeesStatus = async ({
  companyId,
  employees,
}: employeesStatusParams) => {
  const res = await handleRoute({
    method: "put",
    path: `v1/companies/${companyId}/employees/status`,
    payload: { employees },
  });
  return res;
};

export async function downloadEmployeesAdjustments({ companyId, employeeId }) {
  const res = await handleRoute({
    method: "get",
    path: `/v1/companies/${companyId}/employees/${employeeId}/employee-adjustments/csv`,
  });
  return res.data;
}
